import $gBhPC$intllistarAEmjs from "../intl/list/ar-AE.mjs";
import $gBhPC$intllistbgBGmjs from "../intl/list/bg-BG.mjs";
import $gBhPC$intllistcsCZmjs from "../intl/list/cs-CZ.mjs";
import $gBhPC$intllistdaDKmjs from "../intl/list/da-DK.mjs";
import $gBhPC$intllistdeDEmjs from "../intl/list/de-DE.mjs";
import $gBhPC$intllistelGRmjs from "../intl/list/el-GR.mjs";
import $gBhPC$intllistenUSmjs from "../intl/list/en-US.mjs";
import $gBhPC$intllistesESmjs from "../intl/list/es-ES.mjs";
import $gBhPC$intllistetEEmjs from "../intl/list/et-EE.mjs";
import $gBhPC$intllistfiFImjs from "../intl/list/fi-FI.mjs";
import $gBhPC$intllistfrFRmjs from "../intl/list/fr-FR.mjs";
import $gBhPC$intllistheILmjs from "../intl/list/he-IL.mjs";
import $gBhPC$intllisthrHRmjs from "../intl/list/hr-HR.mjs";
import $gBhPC$intllisthuHUmjs from "../intl/list/hu-HU.mjs";
import $gBhPC$intllistitITmjs from "../intl/list/it-IT.mjs";
import $gBhPC$intllistjaJPmjs from "../intl/list/ja-JP.mjs";
import $gBhPC$intllistkoKRmjs from "../intl/list/ko-KR.mjs";
import $gBhPC$intllistltLTmjs from "../intl/list/lt-LT.mjs";
import $gBhPC$intllistlvLVmjs from "../intl/list/lv-LV.mjs";
import $gBhPC$intllistnbNOmjs from "../intl/list/nb-NO.mjs";
import $gBhPC$intllistnlNLmjs from "../intl/list/nl-NL.mjs";
import $gBhPC$intllistplPLmjs from "../intl/list/pl-PL.mjs";
import $gBhPC$intllistptBRmjs from "../intl/list/pt-BR.mjs";
import $gBhPC$intllistptPTmjs from "../intl/list/pt-PT.mjs";
import $gBhPC$intllistroROmjs from "../intl/list/ro-RO.mjs";
import $gBhPC$intllistruRUmjs from "../intl/list/ru-RU.mjs";
import $gBhPC$intllistskSKmjs from "../intl/list/sk-SK.mjs";
import $gBhPC$intllistslSImjs from "../intl/list/sl-SI.mjs";
import $gBhPC$intllistsrSPmjs from "../intl/list/sr-SP.mjs";
import $gBhPC$intllistsvSEmjs from "../intl/list/sv-SE.mjs";
import $gBhPC$intllisttrTRmjs from "../intl/list/tr-TR.mjs";
import $gBhPC$intllistukUAmjs from "../intl/list/uk-UA.mjs";
import $gBhPC$intllistzhCNmjs from "../intl/list/zh-CN.mjs";
import $gBhPC$intllistzhTWmjs from "../intl/list/zh-TW.mjs";

var $a65ddfdfdc420955$exports = {};


































$a65ddfdfdc420955$exports = {
    "ar-AE": $gBhPC$intllistarAEmjs,
    "bg-BG": $gBhPC$intllistbgBGmjs,
    "cs-CZ": $gBhPC$intllistcsCZmjs,
    "da-DK": $gBhPC$intllistdaDKmjs,
    "de-DE": $gBhPC$intllistdeDEmjs,
    "el-GR": $gBhPC$intllistelGRmjs,
    "en-US": $gBhPC$intllistenUSmjs,
    "es-ES": $gBhPC$intllistesESmjs,
    "et-EE": $gBhPC$intllistetEEmjs,
    "fi-FI": $gBhPC$intllistfiFImjs,
    "fr-FR": $gBhPC$intllistfrFRmjs,
    "he-IL": $gBhPC$intllistheILmjs,
    "hr-HR": $gBhPC$intllisthrHRmjs,
    "hu-HU": $gBhPC$intllisthuHUmjs,
    "it-IT": $gBhPC$intllistitITmjs,
    "ja-JP": $gBhPC$intllistjaJPmjs,
    "ko-KR": $gBhPC$intllistkoKRmjs,
    "lt-LT": $gBhPC$intllistltLTmjs,
    "lv-LV": $gBhPC$intllistlvLVmjs,
    "nb-NO": $gBhPC$intllistnbNOmjs,
    "nl-NL": $gBhPC$intllistnlNLmjs,
    "pl-PL": $gBhPC$intllistplPLmjs,
    "pt-BR": $gBhPC$intllistptBRmjs,
    "pt-PT": $gBhPC$intllistptPTmjs,
    "ro-RO": $gBhPC$intllistroROmjs,
    "ru-RU": $gBhPC$intllistruRUmjs,
    "sk-SK": $gBhPC$intllistskSKmjs,
    "sl-SI": $gBhPC$intllistslSImjs,
    "sr-SP": $gBhPC$intllistsrSPmjs,
    "sv-SE": $gBhPC$intllistsvSEmjs,
    "tr-TR": $gBhPC$intllisttrTRmjs,
    "uk-UA": $gBhPC$intllistukUAmjs,
    "zh-CN": $gBhPC$intllistzhCNmjs,
    "zh-TW": $gBhPC$intllistzhTWmjs
};


export {$a65ddfdfdc420955$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
